<template>
  <TopGradientBlockLayout v-if="!!current_portfolio.data && !$store.state.investments.assets.assets_list.dirty">
    <template v-if="!!assetsGroupsNoCurrencies.length">
      <InvestmentAssetsFilters/>
      <InvestmentAssetsGroup v-for="(group,i) in assetGroups"
                             :key="i"
                             :group="group"
                             @sort="setGroupSort({type:group.properties.type,sort_by:$event})"/>
    </template>
    <div v-else class="text-xl font-bold text-text leading-tight  text-center">
      {{ $t('noSecurities') }}
    </div>
  </TopGradientBlockLayout>
</template>

<script>
import {mapGetters, mapMutations, mapState} from "vuex";
import TopGradientBlockLayout from "@/components/layouts/cabinet/TopGradientBlockLayout";
import InvestmentAssetsGroup from "@/components/cabinet/Investments/InvestmentAssets/InvestmentAssetsGroup";
import InvestmentAssetsFilters from "@/components/cabinet/Investments/InvestmentAssets/InvestmentAssetsFilters";

export default {
  name: "TheInvestmentsAssets",
  components: {
    InvestmentAssetsFilters,
    InvestmentAssetsGroup,
    TopGradientBlockLayout,
  },
  computed: {
    ...mapState('investments/portfolios', ['current_portfolio']),
    ...mapGetters('investments/assets', ['assetsGroupsNoCurrencies']),
    assetGroups() {
      return this.assetsGroupsNoCurrencies.filter(group => !!group.assets.length)
    }
  },
  methods: {
    ...mapMutations('investments/assets', ['setGroupSort']),
  },
  i18n: {
    messages: {
      en: {
        noSecurities: 'You haven\'t added any securities'
      },
      ru: {
        noSecurities: 'В вашем портфеле еще нет ценных бумаг'
      }
    }
  }
}
</script>